import LaunchIcon from '@mui/icons-material/Launch';
import Button from 'blocks/Button';
import Card from 'blocks/Card';
import Col from 'blocks/Col';
import Row from 'blocks/Row';
import StatusText from 'blocks/StatusText';
import { Title } from 'blocks/Text';
import EmptyBox from 'components/EmptyBox';
import Loading from 'components/Loading';
import Pager from 'components/Pager';
import Table from 'components/Table';
import CheckMilageModal from 'components/modals/CheckMilageModal';
import FlightDetailModal from 'components/modals/FlightDetailModal';
import { priceFormat } from 'helper/common';
import { getAlphabetDate } from 'helper/date';
import Paths from 'helper/paths';
import WithSidebar from 'layouts/WithSidebar';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import ajax from 'utils/ajax';
import urls from 'utils/urls';
import { FlightResponse, FlightTypeInterface } from './history.interface';
import * as S from './history.styles';
const HistoryDiscount = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const checkMilageModal = useRef<any>();
  const flightDetailModal = useRef<any>();
  const [historyLoading, setHistoryLoading] = useState(false);
  const [flights, setFlights] = useState<FlightTypeInterface[]>([]);
  const [pageData, setPageData] = useState({
    count: 0,
    totalPage: 0,
    page: 0,
  });

  useEffect(() => {
    getFlights(pageData.page);
  }, [pageData.page]);

  const getFlights = async (page, qeury?: string) => {
    setHistoryLoading(true);
    let params = `?page=${page}&size=10` + (qeury || '');

    const res = await ajax<FlightResponse>({
      url: urls.historyFreeTicket + params,
      method: 'GET',
    }).finally(() => setHistoryLoading(false));

    if (!res) return;

    setFlights(res.data);
    setPageData({
      page: res.currentPage,
      count: res.totalItems,
      totalPage: res.totalPages,
    });
  };

  const next = () =>
    setPageData({
      ...pageData,
      page: pageData.page + 1,
    });

  const prev = () =>
    setPageData({
      ...pageData,
      page: pageData.page - 1,
    });
  const goToSearch = async () => {
    navigate(Paths.Services.discount().route, { replace: true });
  };

  return (
    <WithSidebar>
      <S.Wrapper>
        {historyLoading ? (
          <Loading />
        ) : (
          <S.History as={Col} justify="stretch">
            <S.parentTitleAndBtn>
              <S.HistoryTitle> {t('pages.services.flight.pages.history.title')} </S.HistoryTitle>
              <Button styleType="default" className=" fs-xs" onClick={goToSearch}>
                {t('pages.services.flight.pages.history.btn')}
              </Button>
            </S.parentTitleAndBtn>
            <S.HistoryContent as={Row}>
              <S.Logs as={Col}>
                <Card>
                  <Col>
                    <S.HistoryHeadTabale as={Row} justify="space-between" align="center">
                      <Title>{t('pages.services.flight.pages.history.flightRecords.title')}</Title>
                    </S.HistoryHeadTabale>

                    {flights.length === 0 ? (
                      <EmptyBox title={t('pages.services.flight.pages.history.flightRecords.emptyText')} />
                    ) : (
                      <Table
                        name="flights"
                        head={[
                          { text: t('pages.services.flight.pages.history.flightRecords.tables.headers.activity') },
                          { text: t('pages.services.flight.pages.history.flightRecords.tables.headers.dirsction') },
                          { text: t('pages.services.flight.pages.history.flightRecords.tables.headers.totalPrice') },
                          { text: t('pages.services.flight.pages.history.flightRecords.tables.headers.createAt') },
                          { text: t('pages.services.flight.pages.history.flightRecords.tables.headers.status') },
                          { text: t('pages.services.flight.pages.history.flightRecords.tables.headers.discountType') },
                          { text: t('pages.miles.claim.sections.flightRecords.tables.headers.action') },
                        ]}
                        rows={flights.map((item) => [
                          { content: `${item.departure} - ${item.destination}` },
                          { content: item.direction || '---' },
                          { content: priceFormat(item.totalFare) || '---' },
                          { content: getAlphabetDate(item.createdAt) || '---' },

                          {
                            content: (
                              <S.Middle
                                as={StatusText}
                                color={item.status === 'init' ? 'warn' : item.status === 'done' ? 'success' : 'error'}
                              >
                                {item.status}
                              </S.Middle>
                            ),
                            className: 'status-table',
                          },
                          {
                            content: (
                              <S.DiscountType>
                                {' '}
                                {(item.DiscountTicket && item.DiscountTicket.name.split('-')[0]) || '-'}
                              </S.DiscountType>
                            ),
                          },
                          {
                            content: (
                              <S.Middle
                                as={Button}
                                iconStart={<LaunchIcon />}
                                type="link"
                                href={Paths.Services.awardTicketResult().route(item.id)}
                              >
                                {t('pages.tickets.list.table.showDetailsCTA')}
                              </S.Middle>
                            ),
                            className: 'action-table',
                          },
                        ])}
                      />
                    )}
                  </Col>
                </Card>
                {flights.length !== 0 && (
                  <Pager page={pageData.page} total={pageData.count} limit={10} next={next} prev={prev} />
                )}
              </S.Logs>
            </S.HistoryContent>
          </S.History>
        )}
      </S.Wrapper>

      <CheckMilageModal ref={checkMilageModal} />
      <FlightDetailModal ref={flightDetailModal} />
    </WithSidebar>
  );
};

export default HistoryDiscount;
